module.exports = __webpack_public_path__ + "static/media/user5.26744961.gif";